<template lang='pug'>
  v-content
    FormSubmitVisitor(v-if="this.destinationPath == 'page-submited-visitor' && authorized" :dataVisitor="dataVisitor" :visitorInfo="visitorInfo" :ipForm="ipForm" :visitorToken="visitorToken")
    FormInduction(v-else-if="this.destinationPath == 'page-induction' && authorized" :dataVisitor="dataVisitor" :visitorInfo="visitorInfo" :ipForm="ipForm" :visitorToken="visitorToken")
    ExpiredLinkView(v-else-if="!authorized")
</template>
<script>

import FormSubmitVisitor from "../components/FormSubmitVisitor.vue"
import FormInduction from "../components/FormInduction.vue"
import ExpiredLinkView from "../components/ExpiredLinkView.vue"
import dayjs from 'dayjs';
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import jwt_decode from "jwt-decode";
import axios from 'axios';
import { mapState } from "vuex";
export default {
  name: "SubmitedVisitor",
  components: {
  FormSubmitVisitor,
  FormInduction,
  ExpiredLinkView
  },
  data() {
    return {
      dataVisitor: {},
      visitorInfo :{},
      ipForm : '',
      visitorToken :{},
      destinationPath: '',
      authorized: true,
    };
  },
    computed: {
    ...mapState(["API_URL"])
  },
  async mounted() {
    const p = this.$route.params;
    const formCode = this.$route.query.formCode;
    this.destinationPath = this.$route.path.split('/')[1];
    const decoded = jwt_decode(p.token);
    this.dataVisitor = decoded
    this.ipForm = formCode
    this.visitorToken = p 
    const config = {
        method: "get",
        url: `${this.API_URL}/v1/requests/find-visitor`,
        headers: {"Authorization": `Bearer ${p.token}`}
    };
    const result = await axios(config);
    const data = result.data.data;
    dayjs.extend(isSameOrBefore);
    const beforeKunjunganEnd = dayjs().isSameOrBefore(dayjs(decoded.endKunjungan), "day");  
    if (this.destinationPath == 'page-submited-visitor')
      this.authorized = data.status == 16 && beforeKunjunganEnd;
    else if (this.destinationPath == 'page-induction')
      this.authorized = (data.inductionStatus == 16 && data.status == 7) && beforeKunjunganEnd;
    if (data) this.visitorInfo = data;
  },
  watch: {
  },
};
</script>
